<template>
  <!-- 検査解析メニュー画面 -->
  <div id="kensaMenu">
    <div id="container-center">
      <div class="title is-3">検査・解析サービス一覧</div>
      <div class="grid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <li v-if="isActive([role.role_admin,role.role_hospital,role.role_dealer]) && isEnableService(serviceId, service.hst)">
              <div class="contents">
                <router-link :to="{name:'HSTRequest', params:{id:'sp'}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-hospital-building mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">睡眠検査機器<br>配送ｻｰﾋﾞｽ申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_hospital,role.role_dealer]) && isEnableService(serviceId, service.psg)">
              <div class="contents">
                <router-link :to="{name:'PSGRequest', params:{id:'full'}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-clipboard-pulse-outline mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">解析申込み<br /><span class="subtext12">(フルPSG検査)</span></div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_hospital,role.role_dealer]) && isEnableService(serviceId, service.psg)">
              <div class="contents">
                <router-link :to="{name:'PSGRequest', params:{id:'easy'}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-clipboard-pulse-outline mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">解析申込み<br /><span class="subtext12">(簡易検査)</span></div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_hospital,role.role_corporation,role.role_dealer, role.role_accommodations]) && serviceId != 0">
              <div class="contents">
                <router-link to="/guest/RequestFormList">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-text-box-multiple-outline mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">検査申請一覧</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link to="/guest/home">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-keyboard-return mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">サービス一覧に戻る</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";

export default {
  name: "kensaMenu",
  methods: {
    isActive: function(roles){
      return (roles.indexOf(this.roleId) >= 0);
    },
  },
  created: async function(){
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var belongsId = userInfo.belongsId
    var roleId = Number(userInfo.roleId);
    var serviceId = userInfo.useServiceId; 
    return {
      role: role,
      roleId: roleId,
      service:service,
      serviceId:serviceId,
      userInfo,
      belongsId,
    };
  },
  components: {
  }
};
</script>

<style lang="scss" >
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: 900px;
  margin: 0 auto;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 150px 1fr 100px;
  height: 100vh;
}

/*デザイン設定*/
.tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tile-container > li {
  height: 150px;
  width: 150px;
  padding: 5px;
  background: linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 150px;
  width: 150px;
  text-align: center;
  vertical-align: middle;
}

/*グリッド設定*/
.tile-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}
.subtext12 {
  font-size: 12px;
}
.link {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/kensaMenu.vue